<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-29 18:34:55
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Punch\PunchManage\components\Bluetooth\newBluetooth.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-11-17 17:36:50
-->
<template>
  <normalDialog
    :dialog="show"
    :title="$t('label_essweb_punchManage_list_bluetooth_dialog_newTitle')"
    @close="closeDialog"
    :width="680"
    maxWidth="680"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="pt-0 pb-0">
            <v-switch
              color="primary"
              v-model="Data.status"
              :label="
                Data.status
                  ? $t(
                      'label_essweb_punchManage_list_bluetooth_dialog_activeLabel'
                    )
                  : ''
              "
            ></v-switch>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :TrigerInit="show"
              :bindData="Data.criteria_bluetooth_name"
              maxlength="100"
              @change="
                (valueArr) => {
                  Data.criteria_bluetooth_name = valueArr;
                }
              "
              :label="
                $t('label_essweb_punchManage_list_bluetooth_dialog_nameLabel')
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :TrigerInit="show"
              maxlength="500"
              :bindData="Data.criteria_bluetooth_description"
              @change="
                (valueArr) => {
                  Data.criteria_bluetooth_description = valueArr;
                }
              "
              :label="
                $t(
                  'label_essweb_punchManage_list_bluetooth_dialog_descriptionLabel'
                )
              "
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              :label="
                $t(
                  'label_essweb_punchManage_list_bluetooth_dialog_majorCodeLabel'
                )
              "
              maxlength="80"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="Data.bluetooth_major_code"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              :label="
                $t(
                  'label_essweb_punchManage_list_bluetooth_dialog_minorCodeLabel'
                )
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
              maxlength="80"
              v-model="Data.bluetooth_minor_code"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_punchManage_list_bluetooth_dialog_siteNameLabel"
              :items="siteList"
              item-text="site_name"
              item-value="uuid"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="Data.site_uuid"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <normalInputTextFiled
              :rules="$GetRules(['_Require_Rules'], [null])"
              maxlength="80"
              :label="
                $t(
                  'label_essweb_punchManage_list_bluetooth_dialog_bluetoothIdLabel'
                )
              "
              v-model="Data.bluetooth_device_uuid"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              type="date"
              :max="Data.expired_utc_datetime"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :defaultTime="Data.effective_utc_datetime"
              :label="
                $t(
                  'label_essweb_punchManage_list_bluetooth_dialog_effectiveStartDateLabel'
                )
              "
              @change="(time) => (Data.effective_utc_datetime = time)"
            />
          </v-col>
          <!-- <v-col  xs='12' sm="6" md='6' lg='6' cols="12">
            <v-sheet class="text--secondary">Time Zone</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              single-line
              v-model="Data.effective_time_zone"
              dense
              placeholder="time zone"
              filled
            >
              <template v-slot:no-data> <noContent /> </template>
              </v-select>
          </v-col>-->
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <DateTimePicker
              type="date"
              :min="Data.effective_utc_datetime"
              :defaultTime="Data.expired_utc_datetime"
              :label="
                $t(
                  'label_essweb_punchManage_list_bluetooth_dialog_expiredEndDateLabel'
                )
              "
              @change="(time) => (Data.expired_utc_datetime = time)"
            />
          </v-col>
          <!-- <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchManage_list_bluetooth_dialog_timeZoneLabel")
            }}</v-sheet>
            <v-select
              :items="staticZone"
              item-text="text"
              item-value="utc"
              single-line
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              v-model="Data.expired_time_zone"
              dense
              :placeholder="
                $t(
                  'label_essweb_punchManage_list_bluetooth_dialog_timeZoneLabel'
                )
              "
              filled
            >
              <template v-slot:no-data> <noContent /> </template>
            </v-select>
          </v-col> -->
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_punchManage_list_bluetooth_dialog_remarkLabel")
            }}</v-sheet>
            <v-text-field
              dense
              single-line
              maxlength="500"
              filled
              :placeholder="
                $t('label_essweb_punchManage_list_bluetooth_dialog_remarkLabel')
              "
              v-model="Data.remarks"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions newBtn @new="toNew" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newBluetooth",
  computed: {
    ...mapGetters(["companyLang", "staticZone", "defaultUTC"]),
  },
  props: { show: { default: false, type: Boolean } },
  data() {
    return {
      siteList: [],
      Data: {
        status: 0,
        criteria_bluetooth_name: "",
        criteria_bluetooth_description: "",
        bluetooth_device_uuid: "",
        bluetooth_major_code: "",
        bluetooth_minor_code: "",
        site_uuid: "",
        effective_utc_datetime: "",
        effective_time_zone: "",
        expired_utc_datetime: "",
        expired_time_zone: "",
        criteria_type_uuid: "",
        remarks: "",
      },
    };
  },
  watch: {
    show(val) {
      if (!val) {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.Data = {
          status: 0,
          criteria_bluetooth_name: "",
          criteria_bluetooth_description: "",
          bluetooth_device_uuid: "",
          bluetooth_major_code: "",
          bluetooth_minor_code: "",
          site_uuid: "",
          effective_utc_datetime: "",
          effective_time_zone: "",
          expired_utc_datetime: "",
          expired_time_zone: "",
          criteria_type_uuid: "",
          remarks: "",
        };
      }
    },
    "Data.expired_time_zone": function (val) {
      this.Data.effective_time_zone = val;
    },
  },
  mounted() {
    this.Data.criteria_bluetooth_name = this.$getCommonLangKey(
      this.companyLang
    );
    this.Data.criteria_bluetooth_description = this.$getCommonLangKey(
      this.companyLang
    );
    //   this.Data.bluetooth_major_code = this.$getCommonLangKey(
    //   this.companyLang
    // );
    //   this.Data.bluetooth_minor_code = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.Data.effective_time_zone = this.defaultUTC;
    this.Data.expired_time_zone = this.defaultUTC;
    this.getSiteList();
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    getSiteList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/get-site-list/",
      }).then((res) => {
        res.data.map((item) => {
          item.site_name = that.$getCommonLangValue(item.site_name);
        });
        that.siteList = res.data;
      });
    },
    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onNew", "bluetooth", this.Data);
    },
  },
};
</script>
